<section modalContainer invisibleWhitespace>
  <app-modal-header header (close)="close()"
    >{{ label() }} 선택</app-modal-header
  >

  <section class="flex flex-col">
    <div class="p-4">
      <app-input
        class="w-full"
        [debounce]="300"
        [(value)]="query"
        icon="mdi:search"
        placeholder="검색어를 입력해주세요."
      />
    </div>
    <!-- 목록 -->
    <div class="flex flex-col gap-1 p-1 h-[30rem] overflow-y-scroll">
      @for (item of currentGroupArray(); track $index) {
        <app-select-group-wrapper
          (valuesChange)="handleChange($event)"
          [bindLabel]="bindLabel()"
          [bindValue]="bindValue()"
          [item]="item"
          [values]="values()"
        />
      }
      @if (groupArray()?.length === 0) {
        <div class="flex flex-col justify-center gap-1">
          <div class="flex flex-col items-center justify-center h-full gap-3">
            <p class="pt-12 text-sm text-gray-400">검색결과가 없습니다</p>
            @if (query()) {
              <p class="text-sm text-gray-800">'{{ query() }}'</p>
            }
          </div>
        </div>
      }
    </div>

    <!-- 태그 없음 -->

    <div class="flex w-full justify-between">
      <div
        class="w-full border-t px-4 py-2 flex flex-col gap-2.5 min-h-[75px]"
        style="white-space: nowrap"
      >
        <p class="text-sm font-semibold text-gray-800">
          선택됨
          <span class="text-primary">{{ values().length }}</span>
        </p>
        @if (values()) {
          <div class="flex gap-2 overflow-x-auto">
            @for (selected of selecteds(); track $index) {
              @let content = selectHelper.get(selected, bindLabel() || '');

              <div
                class="flex items-center gap-1 px-2 py-1 bg-gray-100 rounded-lg w-fit"
              >
                <p class="text-xs xl:text-base text-gray-500">
                  {{ content }}
                </p>
              </div>
            }
          </div>
        } @else {
          <p class="text-sm text-center text-gray-400">태그를 추가해주세요</p>
        }
      </div>
    </div>
  </section>

  <div
    footer
    class="w-full flex items-center md:border-none md:self-end border-t md:p-3 p-4 gap-2.5"
  >
    <app-button color="gray" variant="outline" expand (click)="close()"
      >취소
    </app-button>

    <app-button expand (click)="apply()">적용 </app-button>
  </div>
</section>
